import { useMount } from 'ahooks';
import React, { useState } from 'react';
import { ResponsiveImage } from '../../parts/media/ResponsiveImage';
import { formatMoney } from '@shopify/theme-currency';

const BundleUpsell = (props) => {
  const { node } = props;
  const [bundlesData, setBundlesData] = useState(null);
  useMount(() => {
    try {
      let bundlesData = JSON.parse(document.querySelector('[data-bundle-upsells]')?.innerHTML);
      setBundlesData(bundlesData);
    } catch (error) {
      console.log(error);
    }
  });

  if (!bundlesData) {
    return null;
  }

  return (
    <section className="bundles-upsell">
      <h6>Bundle & Save</h6>
      <div className="bundles-upsell__products">
        {bundlesData.map((bundle, index) => {
          return (
            <div className="card">
              <figure className="card__item" role="none">
                <ResponsiveImage image={bundle.featured_image}></ResponsiveImage>
              </figure>
              <div className="card__details">
                <h4>
                  <a href={`/products/${bundle.handle}`}>{bundle.title}</a>
                </h4>
                <div className="price">{formatMoney(bundle.price)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BundleUpsell;
